import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Dbindexflds } from '../../../../../core/entities/dbindexflds.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsDbindexfldsComponent } from './dialogs-dbindexflds/edit-dialogs-dbindexflds/edit-dialogs-dbindexflds.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-dbindexflds',
  templateUrl: './dbindexflds.component.html',
  styleUrls: ['./dbindexflds.component.scss']
})
export class DbindexfldsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  dbindexfld: Dbindexflds = new Dbindexflds();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
              private dialog: MatDialog,
              private translateService: TranslateService) {
              super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllDbindexflds();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla dbindexflds
  */
  private getAllDbindexflds(): void {
    this.loading = true;
    this.internalHomeService.allDbindexflds().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un dbindexfld
  * @param typerun Opcional. dbindexfld vacio.
  */
  public createDbindexfld(dbindexfld?: Dbindexflds) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = this.translateService.instant('CREACION.dbindexflds');
    let disabledDbindexfld = false;
    let disabledDbindex = true;
    dbindexfld = this.dbindexfld;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindexfldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindexfld, titulochange, disabledDbindexfld, disabledDbindex}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbindexflds();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un dbindexfld
  * @param typerun Opcional. dbindexfld a editar.
  */
  public editDbindexfld(dbindexfld?: Dbindexflds) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = this.translateService.instant('EDICION.dbindexflds');
    let disabledDbindexfld = false;
    let disabledDbindex = false;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindexfldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindexfld, titulochange, disabledDbindexfld, disabledDbindex}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbindexflds();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un dbindexfld
  * @param dbattr Opcional. Dbindexfld.
  */
  public viewDbindexfld(dbindexfld?: Dbindexflds) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = this.translateService.instant('VIEW.dbindexflds');
    let disabledDbindexfld = true;
    let disabledDbindex = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindexfldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindexfld, titulochange, disabledDbindexfld, disabledDbindex}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * @description
  * Elimina un dbindexfld
  * @param dbindexfld Dbindexfld a eliminar
  */
  public removeTyperun(dbindexfld?: Dbindexflds) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_dbindexflds') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeDbindexflds(dbindexfld).subscribe(res => {
          console.log(res);
          this.getAllDbindexflds();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
